<template>
  <section class="w-full h-[37.5rem] relative p-28 flex items-end font-normal overflow-hidden max-[1024px]:h-[unset] max-[1024px]:px-5 max-[1024px]:py-16">
    <div class="flex flex-col gap-5 z-10">
      <h1 class="text-[3.5rem] leading-[4.1875rem]">{{ title }}</h1>
      <p class="text-[1.125rem] leading-[1.6875rem]">{{ teaser }}</p>
    </div>
    <img
      v-if="windowWidth > 1024"
      :src="leftImage"
      alt="Renters Guide Header Left Image"
      class="h-[56.25rem] max-w-[unset] absolute left-0 bottom-0 -translate-x-1/2"
    />
    <img
      :src="rightImage"
      alt="Renters Guide Header Right Image"
      class="h-[56.25rem] max-w-[unset] absolute left-[min(calc(100%-8rem),max(62rem,calc(100%-56.25rem)))] bottom-0"
    />
  </section>
</template>
<script>
export default {
  name: 'RentersGuideHeader',
  props: {
    title: {
      type: String,
      required: true
    },
    teaser: {
      type: String,
      default: ''
    },
    leftImage: {
      type: String,
      default: ''
    },
    rightImage: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      windowWidth: window.innerWidth
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth
    }
  }
}
</script>